import { useState, useRef, useEffect } from "react";
import { useLocation } from "wouter";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function SearchBar() {
  const [expanded, setExpanded] = useState(false);
  const [query, setQuery] = useState("");
  const [, setLocation] = useLocation();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed.length >= 2) {
      setLocation(`/search?q=${encodeURIComponent(trimmed)}`);
      setExpanded(false);
      setQuery("");
    }
  };

  const handleClose = () => {
    setExpanded(false);
    setQuery("");
  };

  if (!expanded) {
    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setExpanded(true)}
        aria-label="Open site search"
        aria-expanded={false}
        data-testid="button-search-toggle"
      >
        <Search className="h-5 w-5" />
      </Button>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-1">
      <Input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search..."
        aria-label="Search the MTC website"
        className="w-40 sm:w-56"
        data-testid="input-search"
      />
      <Button type="submit" variant="ghost" size="icon" aria-label="Submit search" data-testid="button-search-submit">
        <Search className="h-4 w-4" />
      </Button>
      <Button type="button" variant="ghost" size="icon" aria-label="Close search" onClick={handleClose} data-testid="button-search-close">
        <X className="h-4 w-4" />
      </Button>
    </form>
  );
}
